import React from 'react';

export default function AppLoading(){
  return (
      <div className='page AppLoading-page'>
        <h1>Loading Application...</h1>
      </div>
  );
}